import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Banner = () => {
    return (
        <div className="shadow-xl rounded-md p-4 bg-white mt-4 md:mt-0 text-center">
            <img src="https://www.shutterstock.com/image-illustration/credit-cards-online-shopping-banner-260nw-355524626.jpg" alt="Advertisement" className="w-full rounded-md mb-4" />
            <h3 className="text-xl font-bold mb-2">Invest the way you want</h3>
            <p>Join millions of Indians who trust and love TheFinMaster</p>
            <button className="bg-green-500 text-white px-4 py-2 rounded mt-2">Explore Products</button>
        </div>
    );
};

const BrokerageCalculator = () => {
    const [segment, setSegment] = useState('equity-delivery');
    const [market, setMarket] = useState('nse');
    const [quantity, setQuantity] = useState(50);
    const [buyPrice, setBuyPrice] = useState(1000);
    const [sellPrice, setSellPrice] = useState(1500);
    const [qtyOptionType, setQtyOptionType] = useState('option');
    const [charges, setCharges] = useState({
        turnover: 0,
        pl: 0,
        brokerage: 0,
        stt: 0,
        exchange: 0,
        sebi: 0,
        gst: 0,
        stampDuty: 0,
        netPL: 0,
    });
    const [calculated, setCalculated] = useState(false);

    const calculateCharges = () => {
        const turnover = quantity * (buyPrice + sellPrice);
        const pl = (sellPrice - buyPrice) * quantity;

        const brokerage = Math.min(turnover * 0.0003, 20); // Example: 0.03% or max 20 per trade
        const stt = sellPrice * quantity * 0.001; // Example: 0.1% on sell side
        const exchange = turnover * 0.0000325; // Example: 0.00325%
        const sebi = turnover * 0.0000005; // Example: 0.00005%
        const gst = (brokerage + exchange) * 0.18; // GST
        const stampDuty = buyPrice * quantity * 0.00015; // Example: 0.015% on buy side

        const netPL = pl - (brokerage + stt + exchange + sebi + gst + stampDuty);

        setCharges({
            turnover,
            pl,
            brokerage,
            stt,
            exchange,
            sebi,
            gst,
            stampDuty,
            netPL,
        });

        setCalculated(true);
    };
function Icon({ id, open }) {
      return (
          <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2}
              stroke="currentColor"
              className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
          >
              <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
          </svg>
      );
    }
    
    
      const [activeIndex, setActiveIndex] = useState(0);
    
       
      const faqs = [
        {
            question: 'What is a brokerage calculator?',
            answer: 'A brokerage calculator is a tool that helps you calculate the total cost of a trade, including brokerage fees and all other charges.',
          },
          {
            question: 'Is brokerage charged on both buying and selling?',
            answer: 'Yes, most brokers charge fees on both sides of a transaction.',
          },
          {
            question: 'What all charges are shown in a brokerage calculator?',
            answer: 'It typically shows brokerage, STT, GST, transaction charges, stamp duty, and SEBI charges.',
          },
          {
            question: 'How accurate are online brokerage calculators?',
            answer: 'They are quite accurate when using updated broker-specific and exchange fee structures.',
          },
          {
            question: 'Can I use a brokerage calculator for options and futures?',
            answer: 'Yes, many calculators allow you to compute costs for equity, intraday, delivery, futures, and options.',
          },
          {
            question: 'Are charges the same across brokers?',
            answer: 'No, they vary significantly. Full-service brokers charge more than discount brokers.',
          },
          {
            question: 'What is the minimum brokerage fee?',
            answer: 'Some brokers have a minimum fee (e.g., ₹20) per trade even if your transaction is small.',
          },
          {
            question: 'Do brokerage calculators consider taxes?',
            answer: 'Yes, good calculators consider STT and GST as part of the total cost.',
          },
          {
            question: 'How does intraday trading brokerage differ from delivery?',
            answer: 'Intraday trading usually has lower brokerage rates compared to delivery trading.',
          },
          {
            question: 'How does trading frequency affect brokerage costs?',
            answer: 'Frequent traders might qualify for discounted rates or bulk trading plans.',
          },
          {
            question: 'What happens if I ignore brokerage charges?',
            answer: 'You risk overestimating your profits and making poor trading decisions.',
          },
          {
            question: 'Can I calculate profit/loss using a brokerage calculator?',
            answer: 'Yes, most calculators show net profit or loss after accounting for all charges.',
          },
          {
            question: 'Is brokerage calculated on the trade amount or profit?',
            answer: 'It is calculated on the total trade value, not the profit.',
          },
          {
            question: 'Can beginners use brokerage calculators easily?',
            answer: 'Yes, they are designed to be user-friendly and require minimal input.',
          },
          {
            question: 'Where can I find a reliable brokerage calculator in India?',
            answer: 'You can use trusted platforms like TheFinMaster’s Brokerage Calculator for precise and quick cost breakdowns.',
          },
        ];
      const toggleAccordion = (index) => {
        if (activeIndex === index) {
            // If the clicked question is already expanded, collapse it
            setActiveIndex(null);
        } else {
            // If the clicked question is not expanded, expand it
            setActiveIndex(index);
        };
      }
    return (
        <>
           <nav className="text-gray-500 text-sm my-4 ml-10" aria-label="Breadcrumb">
      <ol className="list-none p-0 inline-flex">
        <li className="flex items-center">
          <Link to="/" className="text-blue-600 hover:text-blue-800 ">Home</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
        <li className="flex items-center">
          <Link to="/financial-tools-calculators" className="text-blue-600 hover:text-blue-800">Financial Tools Calculators</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
          <li className="flex items-center">
          <span className="text-gray-500 ">Brokerage Calculator</span>
        </li> 
      
      </ol>
    </nav>
            <div className='py-4'>

                <div className="container mx-auto p-4 flex flex-col md:flex-row md:space-x-4">
                    <div className="w-full md:w-2/3 p-4 shadow-xl rounded-md bg-white">
                        <h1 className="text-2xl font-bold mb-4">Brokerage Calculator</h1>
                        <div className="mb-4 flex">
                            <button
                                onClick={() => setSegment('equity-delivery')}
                                className={`px-4 py-2 rounded mr-2 ${segment === 'equity-delivery' ? 'bg-blue-500 text-white' : 'bg-gray-200 text-black'}`}
                            >
                                Equity Delivery
                            </button>
                            <button
                                onClick={() => setSegment('equity-intraday')}
                                className={`px-4 py-2 rounded mr-2 ${segment === 'equity-intraday' ? 'bg-blue-500 text-white' : 'bg-gray-200 text-black'}`}
                            >
                                Equity Intraday
                            </button>
                            <button
                                onClick={() => setSegment('fo')}
                                className={`px-4 py-2 rounded ${segment === 'fo' ? 'bg-blue-500 text-white' : 'bg-gray-200 text-black'}`}
                            >
                                F&O
                            </button>
                        </div>
                        {(segment === 'equity-delivery' || segment === 'equity-intraday') && (
                            <div className="mb-4">
                                <label className="block text-gray-700 font-semibold">Market</label>
                                <select
                                    value={market}
                                    onChange={(e) => setMarket(e.target.value)}
                                    className="w-full p-2 border rounded"
                                >
                                    <option value="nse">NSE</option>
                                    <option value="bse">BSE</option>
                                </select>
                            </div>
                        )}
                        {segment === 'fo' && (
                            <>
                                <div className="mb-4">
                                    <label className="block text-gray-700 font-semibold">Quantity Type</label>
                                    <select
                                        value={qtyOptionType}
                                        onChange={(e) => setQtyOptionType(e.target.value)}
                                        className="w-full p-2 border rounded"
                                    >
                                        <option value="option">Option</option>
                                        <option value="future">Future</option>
                                    </select>
                                </div>
                            </>
                        )}
                        <div className="mb-4">
                            <label className="block text-gray-700 font-semibold">Quantity</label>
                            <input
                                type="number"
                                value={quantity}
                                onChange={(e) => setQuantity(parseInt(e.target.value))}
                                className="w-full p-2 border rounded"
                            />
                        </div>
                        <div className="mb-4">
                            <label className="block text-gray-700 font-semibold">Buy Price per Share</label>
                            <input
                                type="number"
                                value={buyPrice}
                                onChange={(e) => setBuyPrice(parseFloat(e.target.value))}
                                className="w-full p-2 border rounded"
                            />
                        </div>
                        <div className="mb-4">
                            <label className="block text-gray-700 font-semibold">Sell Price per Share</label>
                            <input
                                type="number"
                                value={sellPrice}
                                onChange={(e) => setSellPrice(parseFloat(e.target.value))}
                                className="w-full p-2 border rounded"
                            />
                        </div>
                        <button
                            onClick={calculateCharges}
                            className="bg-blue-500 text-white px-4 py-2 rounded"
                        >
                            Calculate
                        </button>
                        {calculated && (
                            <div className="mt-4 p-4 bg-gray-100 rounded-md">
                                <h2 className="text-xl font-bold mb-4">Results</h2>
                                <div className="space-y-2">
                                    <div className="flex justify-between">
                                        <span className="font-semibold">Turnover:</span>
                                        <span>₹ {charges.turnover.toLocaleString()}</span>
                                    </div>
                                    <div className="flex justify-between">
                                        <span className="font-semibold">P&L:</span>
                                        <span>₹ {charges.pl.toLocaleString()}</span>
                                    </div>
                                </div>
                                <h3 className="text-lg font-bold mt-4 mb-2">Charges</h3>
                                <div className="space-y-2">
                                    <div className="flex justify-between">
                                        <span className="font-semibold">Brokerage:</span>
                                        <span>₹ {charges.brokerage.toLocaleString()}</span>
                                    </div>
                                    <div className="flex justify-between">
                                        <span className="font-semibold">STT:</span>
                                        <span>₹ {charges.stt.toLocaleString()}</span>
                                    </div>
                                    <div className="flex justify-between">
                                        <span className="font-semibold">Exchange Charges:</span>
                                        <span>₹ {charges.exchange.toLocaleString()}</span>
                                    </div>
                                    <div className="flex justify-between">
                                        <span className="font-semibold">SEBI Turnover Fees:</span>
                                        <span>₹ {charges.sebi.toLocaleString()}</span>
                                    </div>
                                    <div className="flex justify-between">
                                        <span className="font-semibold">GST:</span>
                                        <span>₹ {charges.gst.toLocaleString()}</span>
                                    </div>
                                    <div className="flex justify-between">
                                        <span className="font-semibold">Stamp Duty:</span>
                                        <span>₹ {charges.stampDuty.toLocaleString()}</span>
                                    </div>
                                </div>
                                <h3 className="text-lg font-bold mt-4 mb-2">Net P&L</h3>
                                <div className="flex justify-between">
                                    <span className="font-semibold">Net P&L:</span>
                                    <span className="text-green-500">₹ {charges.netPL.toLocaleString()}</span>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="w-full md:w-1/3">
                        <Banner />
                    </div>
                </div>
            </div>


            <div className="flex flex-wrap lg:px-6 md:px-6 px-0 py-6" >
            <div className="w-full md:w-2/3 p-4 mx-auto">
          <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
            What is a Brokerage Fee?
          </h1>
          <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
            When you trade stocks, mutual funds, ETFs, or any other securities, you do so through a broker. That broker facilitates your buy and sell orders and charges a fee for the service. This fee is known as the brokerage fee. While it might seem negligible per transaction, it can significantly impact your investment returns over time.
          </p>
          <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
            Brokerage fees can be charged as a flat fee per trade or as a percentage of the total transaction value. These charges are deducted from your capital and are an essential factor in determining your net returns.
          </p>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Why Brokerage Fees Matter More Than You Think
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Many retail investors overlook brokerage charges, assuming them to be minimal. But over the course of multiple trades, especially in intraday and delivery trading, these small costs can add up to thousands of rupees annually.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Understanding your brokerage fees is essential because:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>It helps you evaluate the actual profitability of each trade.</li>
              <li>Frequent traders can optimize their strategies to reduce unnecessary costs.</li>
              <li>It helps in selecting the right brokerage platform based on your trading volume and strategy.</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Introducing the Brokerage Calculator: Your Trading Cost Companion
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              A brokerage calculator is an online tool designed to help traders determine the exact charges involved in a transaction. It accounts for various cost components like:
            </p>
            {/* <div className="overflow-x-auto mt-4">
              <table className="table-auto w-full border-collapse border border-gray-300">
                <thead className="bg-gray-800 text-white">
                  <tr>
                    <th className="px-4 py-2 text-left">Charge Type</th>
                    <th className="px-4 py-2 text-left">Description</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-300 text-gray-600">
                  <tr>
                    <td className="px-4 py-2">Brokerage Fee</td>
                    <td className="px-4 py-2">Charged by the broker for executing your trade; usually a % or flat fee</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2">Securities Transaction Tax (STT)</td>
                    <td className="px-4 py-2">Levied by the government on both buy/sell sides, varies by segment</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2">Exchange Transaction Charges</td>
                    <td className="px-4 py-2">Levied by NSE/BSE for providing trading platforms</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2">GST</td>
                    <td className="px-4 py-2">18% tax applicable on brokerage and transaction fees</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2">SEBI Turnover Fees</td>
                    <td className="px-4 py-2">Nominal charge (currently ₹10 per ₹1 crore of turnover)</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2">Stamp Duty</td>
                    <td className="px-4 py-2">State-wise duty applicable on the buy side only</td>
                  </tr>
                </tbody>
              </table>
            </div> */}
            <div className="mt-4">
  {/* Desktop Table View */}
  <div className="hidden md:block overflow-x-auto">
    <table className="table-auto w-full border-collapse border border-gray-300">
      <thead className="bg-gray-800 text-white">
        <tr>
          <th className="px-4 py-2 text-left">Charge Type</th>
          <th className="px-4 py-2 text-left">Description</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-300 text-gray-600">
        <tr>
          <td className="px-4 py-2">Brokerage Fee</td>
          <td className="px-4 py-2">
            Charged by the broker for executing your trade; usually a % or flat fee
          </td>
        </tr>
        <tr>
          <td className="px-4 py-2">Securities Transaction Tax (STT)</td>
          <td className="px-4 py-2">
            Levied by the government on both buy/sell sides, varies by segment
          </td>
        </tr>
        <tr>
          <td className="px-4 py-2">Exchange Transaction Charges</td>
          <td className="px-4 py-2">
            Levied by NSE/BSE for providing trading platforms
          </td>
        </tr>
        <tr>
          <td className="px-4 py-2">GST</td>
          <td className="px-4 py-2">
            18% tax applicable on brokerage and transaction fees
          </td>
        </tr>
        <tr>
          <td className="px-4 py-2">SEBI Turnover Fees</td>
          <td className="px-4 py-2">
            Nominal charge (currently ₹10 per ₹1 crore of turnover)
          </td>
        </tr>
        <tr>
          <td className="px-4 py-2">Stamp Duty</td>
          <td className="px-4 py-2">
            State-wise duty applicable on the buy side only
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  {/* Mobile Stacked View */}
  <div className="block md:hidden space-y-4">
    {[
      {
        type: "Brokerage Fee",
        desc: "Charged by the broker for executing your trade; usually a % or flat fee",
      },
      {
        type: "Securities Transaction Tax (STT)",
        desc: "Levied by the government on both buy/sell sides, varies by segment",
      },
      {
        type: "Exchange Transaction Charges",
        desc: "Levied by NSE/BSE for providing trading platforms",
      },
      {
        type: "GST",
        desc: "18% tax applicable on brokerage and transaction fees",
      },
      {
        type: "SEBI Turnover Fees",
        desc: "Nominal charge (currently ₹10 per ₹1 crore of turnover)",
      },
      {
        type: "Stamp Duty",
        desc: "State-wise duty applicable on the buy side only",
      },
    ].map((item, index) => (
      <div
        key={index}
        className="border border-gray-300 rounded-lg p-4 bg-white shadow-sm"
      >
        <p className="font-semibold text-gray-800">{item.type}</p>
        <p className="text-sm text-gray-600 mt-2">{item.desc}</p>
      </div>
    ))}
  </div>
</div>

            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Different segments (Equity, Futures, Options, Commodities) attract different rates, and a calculator automates all those distinctions.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              How Does a Brokerage Calculator Work?
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Let's understand it with an example:
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Suppose you buy 50 shares of Infosys at Rs.1500 and sell them at Rs.1600. If your broker charges 0.5% as a brokerage fee, your transaction value would be:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>Buy value = 50 x 1500 = Rs.75,000</li>
              <li>Sell value = 50 x 1600 = Rs.80,000</li>
              <li>Total trade value = Rs.1,55,000</li>
              <li>Brokerage = 0.5% of Rs.1,55,000 = Rs.775</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Add other charges (STT, GST, stamp duty, etc.), and your net profit can decrease significantly if not planned correctly. The brokerage calculator handles all these numbers for you.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Benefits of Using a Brokerage Calculator
            </h1>
            <ul className="list-decimal pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Instant Calculations:</strong> A brokerage calculator gives results in seconds, freeing you from manual computation.</li>
              <li><strong>Transparent Cost Breakdown:</strong> You get a clear picture of all the charges associated with a trade, not just the brokerage.</li>
              <li><strong>Decision-Making Power:</strong> It enables better trading decisions by showing net returns post-costs.</li>
              <li><strong>Broker Comparison:</strong> You can compare costs from different brokers and choose the most economical one.</li>
              <li><strong>Optimizing Trading Volume:</strong> Plan your trade sizes and frequency better based on how costs affect your margins.</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Factors That Affect Brokerage Charges
            </h1>
            <ul className="list-decimal pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Type of Broker:</strong>
                <ul className="list-disc pl-6 mt-2">
                  <li><strong>Full-Service Brokers:</strong> Offer research and advisory services but charge higher fees.</li>
                  <li><strong>Discount Brokers:</strong> Lower fees with DIY platforms.</li>
                </ul>
              </li>
              <li><strong>Type of Trade:</strong>
                <ul className="list-disc pl-6 mt-2">
                  <li><strong>Intraday Trades:</strong> Often have lower brokerage compared to delivery-based trades.</li>
                  <li><strong>F&O Trades:</strong> May attract fixed or lower percentage charges.</li>
                </ul>
              </li>
              <li><strong>Trade Value:</strong> The larger your trade, the higher your brokerage if it's percentage-based.</li>
              <li><strong>Minimum Charges:</strong> Some brokers have a minimum brokerage per trade (e.g., Rs.20), which may apply even on small trades.</li>
              <li><strong>Trading Frequency:</strong> High-volume traders might receive discounts or special packages.</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Full Cost Components in Trading
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              A brokerage calculator doesn’t just show the brokerage fee. It also includes:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>STT (Securities Transaction Tax):</strong> Levied by the government on both buy and sell sides for equities.</li>
              <li><strong>Transaction Charges:</strong> Charged by stock exchanges like NSE or BSE.</li>
              <li><strong>SEBI Charges:</strong> Nominal fee charged by SEBI.</li>
              <li><strong>Stamp Duty:</strong> A state-wise levy on buying securities.</li>
              <li><strong>GST:</strong> Applicable on brokerage and transaction fees.</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Why Ignoring These Charges is Risky
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Even a profitable trade can turn unprofitable if you ignore the complete cost structure. For frequent traders, understanding every rupee that goes out is critical to maintain long-term profitability.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Real-Life Example: Subhash’s Trade
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Subhash buys 20 shares of Hindustan Unilever at Rs.2000 each and sells them at Rs.2100 after 10 days through Broker Z, who charges 0.5% brokerage.
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>Buy = 20 x 2000 = Rs.40,000</li>
              <li>Sell = 20 x 2100 = Rs.42,000</li>
              <li>Total turnover = Rs.82,000</li>
              <li>Brokerage = 0.5% of Rs.82,000 = Rs.410</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Now add STT, stamp duty, GST, and SEBI charges. The total cost might exceed Rs.500+, significantly cutting into Subhash’s Rs.2,000 profit.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Smart Trading: How to Minimize Costs
            </h1>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>Choose discount brokers for lower commissions.</li>
              <li>Use a brokerage calculator before every major trade.</li>
              <li>Opt for annual plans or high-volume discounts if you trade frequently.</li>
              <li>Consider total cost (not just brokerage) before entering trades.</li>
            </ul>
          </div>
        </div>

                <div className="w-full md:w-1/3 p-4">
                    <div className="bg-white shadow-md rounded-lg overflow-hidden">
                        <div className="bg-blue-100 px-4 py-2 border-b border-blue-600 ">
                            <h2 className="text-lg font-semibold ">Popular Categories</h2>
                        </div>
                        <div className="p-2 ">
                        <ul>
                                <Link to='/financial-tools-calculators/swp-calculator'>
                                    <li className="py-2  hover:bg-slate-100 border-b border-gray-300">SWP Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/mutul-fund-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Mutual Fund Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/sukanya-samriddhi-yojana-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Samriddhi Yojana Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/fd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">FD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/rd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">RD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/nps-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NPS Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/hra-exemption-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">HRA Exemption Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/retirement-planning-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Retirement Planning Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">EMI Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/simple-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Simple Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/compound-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Compound Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/nsc-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NSC Calculator</li>

                                </Link><Link to='/financial-tools-calculators/step-up-sip-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Step Up Sip Calculator</li>

                                </Link><Link to='/financial-tools-calculators/income-tax-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Income Tax Calculator</li>
                                    
                                </Link><Link to='/financial-tools-calculators/home-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Home Loan Emi Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/car-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Car Loan Emi Calculator</li>
                                </Link>
                                {/* {categories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
                            </ul>
                        </div>
                    </div>
                    <div className="bg-white shadow-md rounded-lg overflow-hidden mt-4">
                        <div className="bg-blue-100 px-4 py-2 border-b border-blue-600">
                            <h2 className="text-lg font-semibold">More Categories</h2>
                        </div>
                        <div className="p-2">
                        <ul>
                                <Link to='/financial-tools-calculators/gratuity-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Gratuity Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/APY-calculator'>
                                    <li className="py-2 border- hover:bg-slate-100 border-gray-300">APY Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/cagr-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">CAGR Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/gst-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">GST Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/flat-vs-reducing-rate-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Flat Vs Reducing Rate Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/equity-margin-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Equity Margin Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/inflation-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Inflation Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/salary-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Salary Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/brokerage-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Brokerage Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/tds-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">TDS Calculator</li>
                                </Link>
                                {/* {moreCategories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
                            </ul>
                        </div>
                    </div>

                </div>

            </div>
            <div className="max-w-4xl mx-auto lg:px-6 md:px-6 px-2 py-6">
                <h1 className="text-center text-2xl md:text-2xl lg:text-3xl font-bold mb-8">Frequently Asked Questions</h1>
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div key={index} className="border rounded-lg overflow-hidden shadow-md">
                            <button
                                onClick={() => toggleAccordion(index)}
                                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
                            >
                                {faq.question}
                                <Icon id={index} open={activeIndex} />
                            </button>
                            {activeIndex === index && (
                                <div className="p-4 bg-gray-100">
                                    <p className="text-gray-700">{faq.answer}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default BrokerageCalculator;
